import {
  useEffect, useRef, useState
} from "react";
import { useKeycloak } from "@react-keycloak/web";

import formStyles from "src/components/styles/form.module.css";
import Page from "src/components/Page/Page";
import styles from "./KeycloakLoading.module.css";

const keycloakErrorTimeout = 6_000;

export interface ContentProps {
  error?: string;
}

const DefaultContent: React.FC<ContentProps> = ({ error }) => (
  <>
    {
      error && (
        <Page>
          <div className={formStyles.bg}>
            <div className={formStyles.size}>
              <div className={styles.container}>
                <h1 className={formStyles.title}>
                  Lens ID
                </h1>
                <h2 className={formStyles.subtitle}>
                  <span className={styles.error}>
                    {error}
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </Page>
      )
    }
    {
      !error && (
        <div className={styles.bg}>
          <span data-testid="keycloak-not-initialized-text" />
        </div>
      )
    }
  </>
);

export interface Props {
  content?: React.Component<ContentProps>;
}

const KeycloakLoading = ({
  content: Content = DefaultContent
}) => {
  const [keycloakError, setKeycloakError] = useState(false);
  const { initialized } = useKeycloak();

  // useRef is needed to reference the latest value in setTimeout
  const initializedRef = useRef(initialized);

  initializedRef.current = initialized;

  const showKeycloakError = !initialized && keycloakError;

  // If Keycloak was not initialized after timeout, set a flag
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!initializedRef.current) {
        setKeycloakError(true);
      }
    }, keycloakErrorTimeout);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Content error={showKeycloakError ? "Oops! Something went wrong. Please try again in a few minutes!" : undefined} />
  );
};

export default KeycloakLoading;
